import React from "react";
import "./Mission.css";
import MissionIMG from "./MissionIMG";
import { Fade } from "react-awesome-reveal";
import {ThemeProps} from "../../components/styles/themeprops";
import { useTranslation } from "react-i18next";

type SkillsProps = {
  children?: React.ReactNode;
  theme:ThemeProps
};

export default function Skills({
  children,
  theme,
}: SkillsProps) {
  const themeVar = {theme};
   const { t, i18n } = useTranslation();
  return (
    <div className="main" id="skills">
      <div className="skills-header-div">
        <Fade direction="up" duration={2000} damping={0.3} triggerOnce={true}>
          <h1 className="skills-header" style={{ color: themeVar.theme.text }}>
            {t("mission.title")}
          </h1>
        </Fade>
      </div>
      

			<div>
        <div className="skills-main-div">
          <Fade direction="left" duration={2000} triggerOnce={true}>
            <div className="skills-image-div">
              {/* <img
                alt="Ashutosh is Analysing Data"
                src={require(`../../assests/images/${skill.imagePath}`)}
              ></img> */}
							<MissionIMG theme={themeVar.theme} />
            </div>
          </Fade>

          <div className="skills-text-div">
            <Fade direction="right" duration={2000} triggerOnce={true}>
              <div className="mt-5">
                    <p
                      className="subTitle skills-text"
                      style={{ color: theme.secondaryText }}
                    >
                     {t("mission.desc")}
                    </p>
              </div>
            </Fade>
          </div>
        </div>
			</div>
			
    </div>
  );
}
